import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/products/attributes/patterns'

const ProductAttributePatternsApiV2 = {
  /**
   * Get list of `Product Pattern`
   * @param {object} params uri parameter
   * @return {object} Collection of `Product Pattern`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },

  /**
   * Create new product-pattern
   * @param {string} label pattern name
   * @param {file} image
   */
  create: async ({
    label,
    image
  }) => {
    const path     = API_PATH
    const formData = new FormData()
    if (image !== null || image !== '') { formData.append('image', image) }
    formData.append('label', label)

    const response = await axios.post(path, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return response
  },
  /**
   * update existing product-pattern
   * @param {string} id pattern id
   * @param {string} label pattern name
   * @param {file} image
   */
  update: async ({
    id,
    label,
    image
  }) => {
    const path = `${API_PATH}/${id}`

    const formData = new FormData()
    formData.append('image', image)
    formData.append('label', label)

    const response = await axios.patch(path, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return response
  }
}

export default ProductAttributePatternsApiV2